import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { cn } from "~/lib/utils";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { Tooltip } from "~/components/Tooltip";
import { AssetTableRowData } from "../types";

export const ACCOUNT_SEGREGATION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    label: (
        <>
            Account
            <br />
            Segregation
        </>
    ),
    slug: "account_segregation",
    sortsOn: "are_accounts_segregated" as AssetColumns,
    tooltip:
        "Stablecoin's assets are held in separate accounts that are legally distinct from the accounts of the entity that issues the stablecoin.",
    type: ColumnTypes.string,
    width: 160,
    loginRequired: true,
    render: (item) => {
        if (item.isAsset) {
            const {
                are_accounts_segregated,
                accounts_segregated_description: description_raw = "",
            } = item;

            const accounts_segregated_description =
                description_raw?.trim() ?? "";

            // Render Emdash if value is not true or false
            if (are_accounts_segregated === null) {
                return (
                    <div className="flex justify-center">
                        <Emdash />
                    </div>
                );
            }

            const icon = (
                <FontAwesomeIcon
                    icon={
                        are_accounts_segregated === true
                            ? faCheckCircle
                            : faTimesCircle
                    }
                    className={cn("h-4", {
                        "text-blue-400": are_accounts_segregated === true,
                        "text-muted-foreground":
                            are_accounts_segregated !== true,
                    })}
                />
            );

            // Just render icon if description is empty
            if (accounts_segregated_description === "") {
                return <div className="w-full flex justify-center">{icon}</div>;
            }

            return (
                <Tooltip
                    placement="top"
                    tooltipContent={
                        <div className="w-max px-3">
                            <p className="py-1.5 text-sm max-w-120">
                                {accounts_segregated_description}
                            </p>
                        </div>
                    }
                >
                    {({ setTriggerRef }) => (
                        <div
                            className="w-full flex justify-center"
                            ref={setTriggerRef}
                        >
                            {icon}
                        </div>
                    )}
                </Tooltip>
            );
        }

        return (
            <div className="flex justify-center">
                <Emdash />
            </div>
        );
    },
};
